import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import InstallPWA from './components/InstallPWA';
import ChatWidget from './components/ChatWidget';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ImportClients from './pages/ImportClients';
import Notifications from './pages/Notifications';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Tasks from './pages/Tasks';
import ViewClient from './pages/ViewClient';
import EditClient from './pages/EditClient';
import Unauthorized from './pages/Unauthorized';
import Profile from './pages/Profile'; // 👈 NUEVA IMPORTACIÓN
import { FiMessageSquare } from 'react-icons/fi';

// 👇 VERIFICACIÓN: Si algún componente es undefined, veremos el error aquí
console.log('=== VERIFICANDO COMPONENTES ===');
console.log('PrivateRoute:', typeof PrivateRoute);
console.log('Layout:', typeof Layout);
console.log('InstallPWA:', typeof InstallPWA);
console.log('ChatWidget:', typeof ChatWidget);
console.log('Login:', typeof Login);
console.log('Dashboard:', typeof Dashboard);
console.log('Clients:', typeof Clients);
console.log('ImportClients:', typeof ImportClients);
console.log('Notifications:', typeof Notifications);
console.log('Reports:', typeof Reports);
console.log('Users:', typeof Users);
console.log('Tasks:', typeof Tasks);
console.log('ViewClient:', typeof ViewClient);
console.log('EditClient:', typeof EditClient);
console.log('Unauthorized:', typeof Unauthorized);
console.log('Profile:', typeof Profile); // 👈 VERIFICACIÓN DE PERFIL

function App() {
  const [showChat, setShowChat] = useState(false);

  // 👇 Si algún componente es 'undefined', no lo renderizamos
  const isComponentValid = (comp) => typeof comp === 'function';

  return (
    <AuthProvider>
      <Router>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
        
        <Routes>
          {/* Rutas públicas - Solo si los componentes existen */}
          {isComponentValid(Login) && (
            <Route path="/login" element={<Login />} />
          )}
          {isComponentValid(Register) && (
            <Route path="/register" element={<Register />} />
          )}
          {isComponentValid(Unauthorized) && (
            <Route path="/unauthorized" element={<Unauthorized />} />
          )}
          
          {/* Rutas protegidas - Solo si los componentes existen */}
          {isComponentValid(PrivateRoute) && isComponentValid(Layout) && (
            <Route path="/" element={<PrivateRoute />}>
              <Route element={<Layout />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                
                {isComponentValid(Dashboard) && (
                  <Route path="dashboard" element={<Dashboard />} />
                )}
                {isComponentValid(Clients) && (
                  <Route path="clients" element={<Clients />} />
                )}
                {isComponentValid(ViewClient) && (
                  <Route path="clients/:clientNumber" element={<ViewClient />} />
                )}
                {isComponentValid(EditClient) && (
                  <Route path="clients/edit/:clientNumber" element={<EditClient />} />
                )}
                {isComponentValid(ImportClients) && (
                  <Route path="clients/import" element={<ImportClients />} />
                )}
                {isComponentValid(Notifications) && (
                  <Route path="notifications" element={<Notifications />} />
                )}
                {isComponentValid(Reports) && (
                  <Route path="reports" element={<Reports />} />
                )}
                {isComponentValid(Users) && (
                  <Route path="users" element={<Users />} />
                )}
                {isComponentValid(Tasks) && (
                  <Route path="tasks" element={<Tasks />} />
                )}
                {/* 👇 NUEVA RUTA DE PERFIL */}
                {isComponentValid(Profile) && (
                  <Route path="profile" element={<Profile />} />
                )}
              </Route>
            </Route>
          )}
        </Routes>

        {/* Elementos globales - Solo si existen */}
        {isComponentValid(FiMessageSquare) && (
          <button
            onClick={() => setShowChat(!showChat)}
            className="fixed bottom-4 right-4 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-40"
            title="Chat de coordinación"
          >
            <FiMessageSquare size={24} />
          </button>
        )}
        
        {isComponentValid(ChatWidget) && (
          <ChatWidget isOpen={showChat} onClose={() => setShowChat(false)} />
        )}
        
        {isComponentValid(InstallPWA) && (
          <InstallPWA />
        )}
      </Router>
    </AuthProvider>
  );
}

export default App;